import { get_alarm_detail_breathe_chart_option } from '../AlarmDetailBreatheChartOption.ts';
import { get_alarm_detail_heart_chart_option } from '../AlarmDetailHeartChartOption.ts';

export const waveformMethods = {
	resetWaveformState() {
		if (this.createDataInterval) {
			clearInterval(this.createDataInterval);
			this.createDataInterval = null;
		}

		this.createDataIntervalCount = 0;
		this.websocketData = null;

		this.breathDatas = [];
		this.paintBreathDatas = [];
		this.paintBreathDatasCurrentIndex = 0;

		this.heartDatas = [];
		this.paintHeartDatas = [];
		this.paintHeartDatasCurrentIndex = 0;

		if (this.chart1) {
			this.chart1.clear();
		}
		if (this.chart2) {
			this.chart2.clear();
		}
	},

	openTimer() {
		if (this.createDataInterval) {
			clearInterval(this.createDataInterval);
			this.createDataInterval = null;
		}
		this.createDataInterval = setInterval(() => {
			this.timerTask();
		}, 10);
	},
	timerTask() {
		if (!this.websocketData) return;
		if (this.createDataIntervalCount == 7000) {
			this.createDataIntervalCount = 0;
		}
		this.createDataIntervalCount++;

		if (this.createDataIntervalCount % 100 == 0) {
			if (!this.websocketData) {
				return;
			}
			this.changeBreathArrNew();
			this.changeHeartArrNew();
		}

		if (this.createDataIntervalCount % 6000 == 0) {
			this.changeArithmetic(0);
		}

		if (this.createDataIntervalCount % 10 == 0) {
			if (this.breathDatas.length > 0) {
				let tempBreatheDatas = JSON.parse(JSON.stringify(this.breathDatas));

				let breathArr = [];
				breathArr = this.paintBreathDatas;
				breathArr.unshift(this.breathDatas[0]);
				tempBreatheDatas.splice(0, 1);
				this.breathDatas = tempBreatheDatas;
				if (breathArr.length > (672.0 / 2.0) + 10) {
					breathArr.splice(breathArr.length - 1, 1);
				}
				this.paintBreathDatas = breathArr;
			}
		}

		if (this.heartDatas.length > 0) {
			let heartArr = JSON.parse(JSON.stringify(this.paintHeartDatas || []));
			let tempHeartDatas = JSON.parse(JSON.stringify(this.heartDatas));
			const space = 30;
			if (heartArr.length >= this.maxWidth) {
				if (this.paintHeartDatasCurrentIndex >= this.maxWidth) {
					heartArr[this.paintHeartDatasCurrentIndex - this.maxWidth] = '-';
				} else {
					if (this.paintHeartDatasCurrentIndex + space < this.maxWidth) {
						heartArr[this.paintHeartDatasCurrentIndex + space] = '-';
					}
					heartArr[this.paintHeartDatasCurrentIndex] = tempHeartDatas[0];
					tempHeartDatas.splice(0, 1);
					this.heartDatas = JSON.parse(JSON.stringify(tempHeartDatas));
				}
			} else {
				heartArr.push(tempHeartDatas[0]);
				tempHeartDatas.splice(0, 1);
				this.heartDatas = JSON.parse(JSON.stringify(tempHeartDatas));
			}

			if (this.paintHeartDatasCurrentIndex >= this.maxWidth + space) {
				this.paintHeartDatasCurrentIndex = 0;
			} else {
				this.paintHeartDatasCurrentIndex += 1;
			}
			this.paintHeartDatas = JSON.parse(JSON.stringify(heartArr));
		}

		if (this.createDataIntervalCount % 10 == 0) {
			if (this.paintBreathDatas.length > 0) {
				this.chart1.setOption(
					get_alarm_detail_breathe_chart_option(
						this.completionBreatheArray(this.paintBreathDatas),
						this.breatheColor
					)
				);
			}
		}
		if (this.createDataIntervalCount % 3 == 0) {
			if (this.paintHeartDatas.length > 0) {
				this.chart2.setOption(
					get_alarm_detail_heart_chart_option(
						this.completionHeartArray(this.paintHeartDatas),
						this.heartColor,
						[this.paintHeartDatasCurrentIndex + 4, this.paintHeartDatas[this.paintHeartDatasCurrentIndex - 1]]
					)
				);
			}
		}
	},
	completionBreatheArray(arr) {
		let num = 346 - arr.length;
		let needArr = JSON.parse(JSON.stringify(arr));
		for (let i = 0; i < num; i++) {
			needArr.push('-');
		}
		return needArr;
	},
	completionHeartArray(arr) {
		let num = this.maxWidth - arr.length;
		let needArr = JSON.parse(JSON.stringify(arr));
		for (let i = 0; i < num; i++) {
			needArr.push('-');
		}
		return needArr;
	},
	changeBreathArrNew() {
		if (this.breathDatas.length > 10) {
			return;
		}
		let newBreathBpm = this.breathBpm == '--' ? 15 : this.breathBpm;
		let BreathWave_f;
		let BreathWave_Ytemp = [];
		BreathWave_f = newBreathBpm / 60.0;

		let Buff_BreathWave_Y_Flt_temp = this.Buff_BreathWave_Y_Flt;
		let Phi_temp = this.Phi;
		let tempBreatheDatas = JSON.parse(JSON.stringify(this.breathDatas));

		for (let i = 0; i < 10; i++) {
			let tempSin = 5 * Math.cos(((2 * 3.14 * BreathWave_f) / 10.0) * (i + 1) + Phi_temp);
			Buff_BreathWave_Y_Flt_temp.push(tempSin);
			Buff_BreathWave_Y_Flt_temp.splice(0, 1);
			let Buff_BreathWave_Y_FltSum = Buff_BreathWave_Y_Flt_temp.reduce(function (a, b) {
				return a + b;
			});
			if (this.breathBpm == 0) {
				BreathWave_Ytemp.push(-5);
			} else {
				BreathWave_Ytemp.push(Buff_BreathWave_Y_FltSum);
			}
		}
		Phi_temp = (Phi_temp + ((2 * 3.14 * BreathWave_f) / 10) * 11) % (2 * 3.14);

		let breathDatas_temp = tempBreatheDatas.concat(BreathWave_Ytemp);

		this.Phi = Phi_temp;
		this.breathDatas = breathDatas_temp;
		this.Buff_BreathWave_Y_Flt = Buff_BreathWave_Y_Flt_temp;
	},
	changeHeartArrNew() {
		if (this.heartDatas.length > 100) {
			return;
		}
		let newHeartBpm = this.heartBpm == '--' ? 70 : this.heartBpm;
		let HeartWave_Y = [];
		if (newHeartBpm > 80) {
			newHeartBpm = 80;
		} else if (newHeartBpm < 65) {
			newHeartBpm = 65;
		}
		let RR = (60 / newHeartBpm) * 1000;
		let T_cnt_new = Math.round((RR / 1000) * 100);
		let HeartWave_TP_cnt = T_cnt_new - 66;

		let pointer_temp = this.pointer;
		let HeartWave_Y_Mode_temp = JSON.parse(JSON.stringify(this.HeartWave_Y_Mode));
		let T_cnt_present_temp = this.T_cnt_present;
		let tempHeartDatas = JSON.parse(JSON.stringify(this.heartDatas));

		for (let i = 0; i < 100; i++) {
			pointer_temp = pointer_temp + 1;
			HeartWave_Y.push(HeartWave_Y_Mode_temp[pointer_temp - 1]);
			if (pointer_temp >= T_cnt_present_temp) {
				let zerosArr = [];
				for (let index = 0; index < HeartWave_TP_cnt; index++) {
					zerosArr.push(0);
				}
				HeartWave_Y_Mode_temp = this.Buff_Electrocardiogram_QRST.concat(
					zerosArr,
					this.Buff_Electrocardiogram_PR
				);
				T_cnt_present_temp = HeartWave_Y_Mode_temp.length;
				pointer_temp = 0;
			}
		}

		let heartDatas_temp = tempHeartDatas.concat(HeartWave_Y);

		this.HeartWave_Y_Mode = HeartWave_Y_Mode_temp;
		this.T_cnt_present = T_cnt_present_temp;
		this.pointer = pointer_temp;
		this.heartDatas = heartDatas_temp;
	},
};
